import React from "react";
import ClaudeCodeDashboard from "./components/ClaudeCodeDashboard";

const ClaudeCode: React.FC = () => <ClaudeCodeDashboard />;

export default ClaudeCode;
